import { useMemo, useState } from 'react'

type PaginationStateType = {
  offset: number
  limit: number
}
const InitialPaginationState: PaginationStateType = {
  offset: 0,
  limit: 10,
}
export type PaginationConfigType<T> = { data: T[] | null; count: number } & Partial<PaginationStateType>
export default function usePagination<T = unknown>({ data, count, limit, offset }: PaginationConfigType<T>) {
  const [config, setConfig] = useState({ limit: limit ?? InitialPaginationState.limit, offset: offset ?? InitialPaginationState.offset })
  const current = config.offset + 1
  const lastPage = data && data.length ? Math.ceil(count / config.limit) : null

  const hasNext = lastPage && config.offset < lastPage && current !== lastPage ? true : false

  const hasPrevious = useMemo(() => config.offset > 0, [config.offset])

  const onNext = () => {
    if (!hasNext) return
    setConfig((prev) => ({ ...prev, offset: prev.offset + 1 }))
  }

  const onPrevious = () => {
    if (!hasPrevious) return
    setConfig((prev) => ({ ...prev, offset: prev.offset - 1 }))
  }

  return {
    current,
    config,
    lastPage,
    hasNext,
    hasPrevious,
    onNext,
    onPrevious,
    setConfig,
  }
}
